import type { GetPaymentsParams } from "@repo/types";
import { useQuery } from "@tanstack/react-query";
import { getPayments } from "../api/paymentApi";

export const usePayments = (params: GetPaymentsParams) => {
  return useQuery({
    queryKey: [
      "payments",
      params.page,
      params.limit,
      params.sortBy,
      params.sortOrder,
      params.filterKey,
      params.filterValue,
      params.accountId,
      params.startDate,
      params.endDate,
    ],
    queryFn: () => getPayments(params),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};


